
interface PricingButtonProps {
  onClick: () => void;
  variant: "default" | "primary";
}

const PricingButton = ({ onClick, variant }: PricingButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`w-full py-2 px-4 rounded-md flex items-center justify-center transition-colors text-sm sm:text-base ${
        variant === "primary"
          ? "bg-primary text-primary-foreground hover:bg-primary/90"
          : "bg-black hover:bg-neutral-800 text-white"
      }`}
    >
      Get Started
      <svg
        className="ml-2 h-4 w-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M14 5l7 7m0 0l-7 7m7-7H3"
        />
      </svg>
    </button>
  );
};

export default PricingButton;
